import axios from 'axios';
import React, { useEffect, useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { valdiatePage, processStrWithSpaceAndSpecalChars } from '../../global';
import { getBranchesAccountNo, getLocs, saveLocation, updateLocation } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import Pagination from '../../components/paginations';
import SeeMoreModal from '../../components/SeeMoreModal';

const Location = () => {
    const dispatch = useDispatch();
    const { userInfo, accounts } = useSelector(state => state.appData);

    const history = useHistory();

    const d = {
        accountNo: '',
        branchCode: '',
        rtnBranchCode: '',
        locationName: '',
        locationAddress: '',
        locationId: 0,
        vendorShopId: '',
        createdBy: userInfo?.id || 0,
        IsActive: false,
        isReturned: false,
        returnedAddress: "",
        creditClientId: ""
    }

    const [data, setData] = useState(d);
    const [branches, setBranches] = useState([]);
    const [viewType, setViewType] = useState('list');
    const [grid, setGrid] = useState([]);

    
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        locationId: '',
        LocationName: ''
    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'Account', name: 'Account No', searchBox: false, visible: true},
        {key: 'locationId', name: 'Location ID', searchBox: true, visible: true},
        {key: 'vendorShopId', name: 'Vendor/Shop ID', searchBox: false, visible: true},
        {key: 'LocationName', name: 'Location Name', searchBox: true, visible: true},
        {key: 'Branch', name: 'Branch', searchBox: false, visible: true},
        {key: 'LocationAddress', name: 'Location Address', searchBox: false, visible: true},
        {key: 'IsActive', name: 'IsActive', searchBox: false, visible: true},
        {key: '', name: <b>Edit</b>, searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (!valdiatePage('/location')) {
            history.push('/login');
        }
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, []);

    useEffect(() => {
        if (viewType === 'list') {
            (async function () {
                dispatch(setLoading({ data: true }));
                const rs = await getLocs(userInfo.id);
                dispatch(setLoading({ data: false }));
                if (rs.ok) {
                    setGrid(rs.data);
                    setOriginalGrid(rs.data);
                }
            }())
        }
    }, [viewType])

    const updateData = (key, val) => { setData(prev => { return { ...prev, [key]: val } }); }

    const onAdd = () => {
        setViewType('add')
        setData(d)
    }

    const onSave = async () => {

        if (!data.accountNo) {
            alert('Select Account');
            return;
        }

        if (!data.branchCode) {
            alert('Select Branch');
            return;
        }

        if (!data.locationName || data.locationName.trim() === '') {
            alert('Enter Location Name');
            return;
        }

        // if (!data.vendorShopId || data.vendorShopId.trim() === '') {
        //     alert('Enter Vendor/Shop ID');
        //     return;
        // }

        if (!data.locationAddress || data.locationAddress.trim() === '') {
            alert('Enter Location Address');
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await saveLocation({
            accountNo: data.accountNo,
            branchCode: data.branchCode,
            rtnBranchCode: data.rtnBranchCode,
            locationAddress: data.locationAddress,
            locationName: data.locationName,
            vendorShopId: data.vendorShopId,
            createdBy: data.createdBy,
            isReturned: data.isReturned,
            returnedAddress: data.returnedAddress
        });
        dispatch(setLoading({ data: false }));
        alert(rs.msg);
        if (rs.sts == 0) {
            setData(d);
            setViewType('list')
        }
    }

    const onEdit = async (x) => {
        getBranchesAccountNo(x.Account).then(x => {
            if (x && x.length > 0)
                setBranches(x);
        })

        console.log(x);
        setData(prev => {
            return {
                ...prev,
                accountNo: x.Account,
                branchCode: x.Branch,
                locationAddress: x.LocationAddress,
                locationName: x.LocationName,
                locationId: x.locationId,
                vendorShopId: x.vendorShopId,
                IsActive: x.IsActive,
                isReturned: x.isReturned,
                returnedAddress: x.returnedAddress,
                rtnBranchCode: x.rtnBranch,
                creditClientId: x.CreditClientId
            }
        })
        setViewType('edit')
    }

    const onUpdate = async () => {

        if (!data.locationName || data.locationName.trim() === '') {
            alert('Enter Location Name');
            return;
        }

        // if (!data.vendorShopId || data.vendorShopId === 0) {
        //     alert('Enter Vendor/Shop ID');
        //     return;
        // }

        if (!data.locationAddress || data.locationAddress.trim() === '') {
            alert('Enter Location Address');
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await updateLocation(data.locationId, { locAddress: data.locationAddress, locName: data.locationName, vendorShopId: data.vendorShopId, isActive: data.IsActive, 
            isReturned: data.isReturned, returnAddress: data.returnedAddress, rtnBranchCode: data.rtnBranchCode, creditClientId: data.creditClientId  });
        dispatch(setLoading({ data: false }));
        alert(rs.msg);
        if (rs.ok == 0) {
            setData(d);
            setViewType('list')
        }
    }


    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Locations</h1>
        </div>
        {
            viewType === 'list' ?
                <>
                    <div className="card" style={{ padding: 10 }}>
                        <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={onAdd}>Add Location</button></div>
                            {
                                <>
                                    <Pagination
                                        setGrid={setGrid}
                                        searchObjInit={searchObjInit}
                                        searchObject={searchObject}
                                        originalGrid={originalGrid}
                                        setPage={setPage}
                                        setPageLimit={setPageLimit}
                                        requestSort={requestSort}
                                        sortConfig={sortConfig}
                                        updateSearchData={updateSearchData}
                                        sortedArray={sortedArray}
                                        data={data}
                                        dataCount={grid.length}
                                        pageLimit={pageLimit}  
                                        gridKeys={gridKeys}
                                        page={page}
                                        grid={
                                            sortedArray && sortedArray.length > 0 ? sortedArray.map((x, index) =>
                                                <tr key={index}>
                                                    <td>{(index + 1)+(page*pageLimit)}</td>
                                                    <td>{x.Account}</td>
                                                    <td>{x.locationId}</td>
                                                    <td>{x.vendorShopId}</td>
                                                    <td>{x.LocationName}</td>
                                                    <td>{x.Branch}</td>
                                                    <td style={{ minWidth: 200 }}>
                                                        <SeeMoreModal detail={x.LocationAddress} maxLength={80} />
                                                    </td>
                                                    <td>{x.IsActive ? 'Active' : 'InActive'}</td>
                                                    <td>
                                                        <div><button type='button' className='btn btn-sm btn-primary' onClick={() => onEdit(x)}>Edit</button></div>
                                                    </td>
                                                </tr>)
                                            : <tr><td colSpan={3}>No Locations Found</td></tr>
                                        }
                                    />
                                </>
                            }
                    </div>
                </>
                : viewType === 'edit' ?
                    <div className="card" style={{ padding: 10 }}>
                        <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={() => setViewType('list')}>Back</button></div>
                        <div className="row">
                            <div className="col-lg-3 col-sm-12">
                                <label>Account</label>
                                <input type="text" className="form-control" value={data.accountNo} disabled />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Branches</label>
                                <input type="text" className="form-control" value={data.branchCode} disabled />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Location Name</label>
                                <input type="text" className="form-control" maxLength={49} value={data.locationName} onInput={processStrWithSpaceAndSpecalChars} onChange={e => updateData('locationName', e.target.value)} />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Location Address</label>
                                <textarea className="form-control" maxLength={255} value={data.locationAddress} onInput={processStrWithSpaceAndSpecalChars} onChange={e => updateData('locationAddress', e.target.value)}></textarea>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-sm-12">
                                <label>Location ID</label>
                                <input type="text" className="form-control" value={data.locationId} disabled />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Vendor/Shop ID</label>
                                <input type="text" className="form-control" onInput={processStrWithSpaceAndSpecalChars}  onChange={e => updateData('vendorShopId', e.target.value)} value={data.vendorShopId} />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label style={{ whiteSpace: 'nowrap' }}>Active/Inactive</label><br />
                                <label className="switch">
                                    <input type="checkbox" checked={data.IsActive} onChange={e => updateData('IsActive', e.target.checked)} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-1 col-sm-12">
                                <label style={{ whiteSpace: 'nowrap' }}>Return Address</label><br />
                                <label className="switch">
                                    <input type="checkbox" checked={data.isReturned} onChange={e => updateData('isReturned', e.target.checked)} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            {
                                data.isReturned && <>
                                    <div className="col-lg-6 col-sm-12">
                                        <label></label>
                                        <textarea className="form-control" value={data.returnedAddress} maxLength={255} onInput={processStrWithSpaceAndSpecalChars} onChange={e => updateData('returnedAddress', e.target.value)}></textarea>
                                    </div>

                                    <div className="col-lg-3 col-sm-12">
                                        <label>Return Branches</label>
                                        <select className="form-select" value={data.rtnBranchCode} onChange={e => updateData('rtnBranchCode', e.target.value)}>
                                            <option value="">Select Return Branch</option>
                                            {
                                                branches.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                                            }
                                        </select>
                                    </div>
                                </> 
                            }

                        </div>
                        <div className="row mt-3">
                            <div className="col" style={{ textAlign: 'right' }}>
                                <button type="button" className="btn btn-primary" onClick={onUpdate}>Update</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="card" style={{ padding: 10 }}>
                        <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={() => setViewType('list')}>Back</button></div>
                        <div className="row">
                            <div className="col-lg-3 col-sm-12">
                                <label>Account</label>
                                <select className="form-select" value={data.accountNo} onChange={e => {
                                    updateData('accountNo', e.target.value)
                                    getBranchesAccountNo(e.target.value).then(x => {
                                        if (x && x.length > 0)
                                            setBranches(x);
                                    })
                                    
                                }}>
                                    <option value="">Select Account</option>
                                    {
                                        accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                                    }
                                </select>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Branches</label>
                                <select className="form-select" value={data.branchCode} onChange={e => updateData('branchCode', e.target.value)}>
                                    <option value="">Select Branch</option>
                                    {
                                        branches.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                                    }
                                </select>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Location Name</label>
                                <input type="text" className="form-control" value={data.locationName} onInput={processStrWithSpaceAndSpecalChars} maxLength={49} onChange={e => updateData('locationName', e.target.value)} />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Vendor/Shop ID</label>
                                <input type="text"  className="form-control" value={data.vendorShopId} onInput={processStrWithSpaceAndSpecalChars} onChange={e => updateData('vendorShopId', e.target.value)} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-12 col-sm-12">
                                <label>Location Address</label>
                                <textarea className="form-control" value={data.locationAddress} maxLength={255} onChange={e => updateData('locationAddress', e.target.value)}></textarea>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-1 col-sm-12">
                                <label style={{ whiteSpace: 'nowrap' }}>Return Address</label><br />
                                <label className="switch">
                                    <input type="checkbox" checked={data.isReturned} onChange={e => updateData('isReturned', e.target.checked)} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            {
                                data.isReturned && <>
                                    <div className="col-lg-6 col-sm-12">
                                        <label></label>
                                        <textarea className="form-control" value={data.returnedAddress} maxLength={255} onChange={e => updateData('returnedAddress', e.target.value)}></textarea>
                                    </div> 
                                    <div className="col-lg-3 col-sm-12">
                                        <label>Return Branches</label>
                                        <select className="form-select" value={data.rtnBranchCode} onChange={e => updateData('rtnBranchCode', e.target.value)}>
                                            <option value="">Select Return Branch</option>
                                            {
                                                branches.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                                            }
                                        </select>
                                    </div>
                                </> 
                            }
                        </div>
                        <div className="row mt-3">
                            <div className="col" style={{ textAlign: 'right' }}>
                                <button type="button" className="btn btn-primary" onClick={onSave}>Save</button>
                            </div>
                        </div>
                    </div>
        }

    </section>
}

export default Location
